module.exports = __webpack_public_path__ + "assets/img/00043.2bc00457.png";